import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { Button } from 'components/Button'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { useCallback } from 'react'

export const CopyFlagsButton = observer(() => {
  const rootStore = useRootStore()
  const featureFlagStore = rootStore.featureFlags
  const activeFlags = [...featureFlagStore.flags()].filter(([flag, enabled]) => enabled).map(([flag]) => flag)

  const handlePress = useCallback(() => {
    navigator.clipboard
      .writeText(JSON.stringify(activeFlags))
      .then(() => {
        showToastMessage('Feature flags copied to clipboard')
      })
      .catch((err) => {
        showToastMessage('Failed to copy features to clipboard: ', err)
      })
  }, [activeFlags])

  return (
    <Button size="xl" onPress={handlePress}>
      Copy Active Flags
    </Button>
  )
})
